module.exports = __webpack_public_path__ + "media/images/ui__arrowRight--dark-8020ec07deeaeb99003e3b7560d8bd1e.png";